import LocalStorageService from 'services/localstorage/LocalStorage.service';

const useGetCurrentLocation = (): number | any => {
  const currentLocation = JSON.parse(LocalStorageService.getItem('defaultLocation'));

  return { currentLocation };
};

export default useGetCurrentLocation;
